import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import SneakersArticle from "../pages/sneakers-article/page";
import HoodiesArticle from "../pages/hoodies-article/page";
import BudgetArticle from "../pages/budget-article/page";
import TikTokArticle from "../pages/tiktok-article/page";
import JacketsArticle from "../pages/jackets-article/page";
import AccessoriesArticle from "../pages/accessories-article/page";
import SetsArticle from "../pages/sets-article/page";
import JerseyArticle from "../pages/jersey-article/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/pandabuyspreadsheet-guide", element: <ArticlePage /> },
  { path: "/pandabuyspreadsheet-sneakers", element: <SneakersArticle /> },
  { path: "/pandabuyspreadsheet-hoodies", element: <HoodiesArticle /> },
  { path: "/pandabuyspreadsheet-budget", element: <BudgetArticle /> },
  { path: "/pandabuyspreadsheet-tiktok", element: <TikTokArticle /> },
  { path: "/pandabuyspreadsheet-jackets", element: <JacketsArticle /> },
  { path: "/pandabuyspreadsheet-accessories", element: <AccessoriesArticle /> },
  { path: "/pandabuyspreadsheet-sets", element: <SetsArticle /> },
  { path: "/pandabuyspreadsheet-jersey", element: <JerseyArticle /> },
  { path: "*", element: <NotFound /> },
];

export default routes;